const artistsWishlistES = {
    "view": {
        "table": {
            "title": "Tu lista de deseos de artistas",
            "column": {
                "artist_name": "Nombre del Artista",
                "spotify_id": "ID de Spotify",
                "followers": "Seguidores",
                "popularity": "Popularidad (%)",
                "action": "Acción"
            },
            "dropdown": {
                "action": "Acción",
                "addAsArtist": "Agregar como Artista",
                "delete": "Eliminar"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "message": {
                "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Eliminar Artista {{artistName}} de la Lista de Deseos",
                "body": "¿Estás seguro de que deseas eliminar al artista {{artistName}} de tu lista de deseos?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para aprovechar esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para aprovechar esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    }
};

export default artistsWishlistES;